// extracted by mini-css-extract-plugin
export var circle = "style-module--circle--I5wcJ";
export var divider = "style-module--divider--tSylb";
export var dotsWrapper = "style-module--dotsWrapper--WfuK+";
export var header = "style-module--header--gI+2-";
export var imageWrapper = "style-module--imageWrapper--+zdty";
export var line = "style-module--line--UIoge";
export var linkedin = "style-module--linkedin--bpQkL";
export var mentor = "style-module--mentor--fdi7A";
export var mentorImg = "style-module--mentorImg--QwjCR";
export var mentorsCards = "style-module--mentorsCards--u6spb";
export var modal = "style-module--modal--g8R1Q";
export var modalClose = "style-module--modalClose--EoFkV";
export var modalContentWrapper = "style-module--modalContentWrapper--t9RSW";
export var modalDescription = "style-module--modalDescription--h6Hum";
export var modalImageWrapper = "style-module--modalImageWrapper--G7E7R";
export var modalLine = "style-module--modalLine--dqwS5";
export var modalLinkedin = "style-module--modalLinkedin--t7QCq";
export var modalName = "style-module--modalName--XGASZ";
export var modalSplash = "style-module--modalSplash--3cAly";
export var modalTitle = "style-module--modalTitle--pt2uL";
export var name = "style-module--name--yG-u3";
export var root = "style-module--root--brdn4";
export var title = "style-module--title--XbU+k";
export var titleWithLinkWrapper = "style-module--titleWithLinkWrapper--eK3LG";